import { render, staticRenderFns } from "./reporteTratamientosRealizados.vue?vue&type=template&id=c192990a&scoped=true"
import script from "./reporteTratamientosRealizados.vue?vue&type=script&lang=js"
export * from "./reporteTratamientosRealizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c192990a",
  null
  
)

export default component.exports